module.exports = __webpack_public_path__ + "static/media/mars1.7a8733c3.jpg";